import { createRouter, createWebHashHistory } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import PatientsView from "@/views/PatientsView.vue";
import applogin from "@/views/applogin.vue";
import patientsApp from "@/views/patientsApp.vue";
import detailsApp from "@/views/detailsApp.vue";
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: LoginView
    },
    {
      path: "/patients",
      name: "patients",
      component: PatientsView
    },
    {
      path: "/login",
      name: "login",
      component: LoginView
    },
    {
      path: "/applogin",
      name: "applogin",
      component: applogin
    },
    {
      path: "/patientsApp",
      name: "patientsApp",
      component: patientsApp
    },
    {
      path: "/detailsApp",
      name: "detailsApp",
      component: detailsApp
    },
  ]
});

export default router;
